import Item from '../dropdowns/DropdownItem';
import Service from '../lab/services/Service.tsx';
import { backend } from '../constants/constants.js';
import Repository from '../lab/repositories/Repository.tsx';
import Build from '../lab/builds/Build.tsx';

var TOKEN = undefined;

class ServiceBus {
  private readonly apiRoot = backend;
  getToken() {
    return TOKEN !== null && TOKEN !== undefined
      ? TOKEN
      : localStorage.getItem('_a');
  }

  async getAuthStatus(): Promise<Item[]> {
    return this.get('auth/status');
  }

  async getServices(): Promise<Item[]> {
    return this.getPublic('services/list');
  }

  async getProducts(): Promise<Item[]> {
    return this.getPublic('products/list');
  }

  async getApps(): Promise<Item[]> {
    return this.getPublic('apps/list');
  }

  async getServiceList(): Promise<Service[]> {
    return this.get('api/services/list');
  }

  async addService(service: Service) {
    return this.post('api/services/add', service);
  }

  async deleteService(serviceId: string) {
    return this.post('api/services/delete', {
      serviceId: serviceId,
    });
  }

  async updateService(service: Service) {
    return this.post('api/services/update', service);
  }

  async getRepositoryList(sid: string): Promise<Repository[]> {
    return this.get('api/repos/list/' + sid);
  }

  /**
   *
   * @param sid - service ID that the repo will be tied to
   * @param repo
   * @returns
   */
  async addRepository(sid: string, repo: Repository) {
    return this.post('api/repos/add', repo);
  }

  async getBuildList(sid: string): Promise<Build[]> {
    return this.get('api/builds/list/' + sid);
  }

  /**
   * Deploys a build on the specified service
   *
   * @param buildId
   * @returns
   */
  async deployBuild(build) {
    return this.post('api/builds/deploy', build);
  }

  /**
   *
   * @param sid - service ID that the repo will be tied to
   * @param repo
   * @returns
   */
  async addBuild(build: Build) {
    return this.post('api/builds/add', build);
  }
  async getUsers(groupId: string) {
    return this.get('api/users/list/' + groupId);
  }
  async updateUser(user) {
    console.log('Updating user:', user);
    return this.post('api/users/update', user);
  }
  async addUser(user) {
    console.log('Adding user:', user);
    return this.post('api/users/add', user);
  }
  async editUser(user) {
    return this.post('api/users/edit', user);
  }
  async deleteUser(user) {
    return this.post('api/users/delete', user);
  }
  async getResources(sid: String) {
    return this.get('api/resources/list/' + sid);
  }
  login(user, pass) {
    return fetch(this.apiRoot + 'auth/login', {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '',
      },
      body: JSON.stringify({ username: user, password: pass }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Api error: ' + res['message']);
      })
      .then((json) => json);
  }

  signup(user, pass) {
    return fetch(this.apiRoot + '/signup', {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '',
      },
      body: JSON.stringify({ username: user, password: pass }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Api error: ' + res['message']);
      })
      .then((json) => json);
  }

  async get(path) {
    return fetch(this.apiRoot + path, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '',
        Authorization: 'Bearer ' + this.getToken(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Api error: ' + res['message']);
      })
      .then((json) => json);
  }

  async getPublic(path) {
    return fetch(this.apiRoot + path, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '',
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Api error: ' + res['message']);
      })
      .then((json) => json);
  }

  async post(path, data) {
    return fetch(this.apiRoot + path, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '',
        Authorization: 'Bearer ' + this.getToken(),
      },
      body: JSON.stringify(data),
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Api error: ' + res['message']);
    });
  }

  saveToken(token) {
    TOKEN = token;
    window.localStorage.setItem('_a', token);
    console.log('Token saved');
  }
}

export default ServiceBus;
